import { Colours } from './colours';

export const SectorColours = {
  transportColour: Colours.sectors.transport.main,
  industryColour: Colours.sectors.industry.main,
  agricultureColour: Colours.sectors.agriculture.main,
  energyColour: Colours.sectors.energy.main,
  otherColour: Colours.sectors.other.main,
  unknownColour: Colours.unknownColour,
  emissionColour: Colours.emissionColour,

  transportHoverColour: Colours.sectors.transport.light,
  industryHoverColour: Colours.sectors.industry.light,
  agricultureHoverColour: Colours.sectors.agriculture.light,
  energyHoverColour: Colours.sectors.energy.light,
  otherHoverColour: Colours.sectors.other.light,
  unknownHoverColour: Colours.unknownColourLight,
  emissionHoverColour: Colours.emissionColour,

  transportColourDark: Colours.sectors.transport.dark,
  industryColourDark: Colours.sectors.industry.dark,
  agricultureColourDark: Colours.sectors.agriculture.dark,
  energyColourDark: Colours.sectors.energy.dark,
  otherColourDark: Colours.sectors.other.dark,
  unknownColourDark: Colours.unknownColourDark,
  emissionColourDark: Colours.emissionColourDark,
};
